import useAsyncData from "../../../../hooks/use-async-data";
import contractsService from "../../contracts.service";
import ContractsMileageList from "./contracts-mileage-list";
import ContractsMileageListParams from "./contracts-mileage-list-params";

const useContractsMileageList = () => {
  const { isLoading, setIsLoading, isError, setIsError, data, setData } =
    useAsyncData<ContractsMileageList>({ data: [], totalCount: 0 });

  const load = async (
    params: ContractsMileageListParams,
    signal: AbortSignal,
  ): Promise<void> => {
    setIsError(false);
    setIsLoading(true);

    try {
      const mileageContractsList: ContractsMileageList =
        await contractsService.getMileageContractList(params, signal);

      setData(mileageContractsList);
      setIsLoading(false);
    } catch (error) {
      setIsError(true);
    } finally {
      setIsLoading(false);
    }
  };

  return {
    data,
    isError,
    isLoading,
    load,
  };
};

export default useContractsMileageList;
